(function () {
    angular
        .module('tradersyard')
        .service('graph-report-service', GraphReportService)
        .run([
            'graph-api-client',
            'graph-report-service',
            function ($api, $service) {
                $api.factory.report = $service;
            },
        ]);

    GraphReportService.$inject = ['graph-api-client', '$uibModal'];

    function GraphReportService($api, $uibModal) {
        this.create = function (entryName, entryId, reportForm, options) {
            if (entryName === 'user') entryName = undefined;

            return $api.post([entryName, entryId, 'report'], reportForm, options);
        };

        this._launchModal = function (component, entryName, entryModel, entryId, initialData) {
            const modal = $uibModal.open({
                component: component,
                backdrop: 'static',
                resolve: {
                    entityInfo: () => ({
                        entryName: entryName,
                        entryModel: entryModel,
                        entryId: entryId,
                    }),
                    initialData: () => initialData,
                },
            });

            return modal;
        };

        this.reportAnything = function (entryName, entryModel, entryId) {
            return this._launchModal('tyReportCommonModal', entryName, entryModel, entryId, {
                reason: 'illegal-content',
            });
        };
    }
})();
